import { Fragment } from "react";
import SegmentContainer from "./segment-container";
import PortableTextPlus from "@/components/portable-text-plus";
import { getIconImage } from "@/lib/utils";
import classNames from "classnames";

export default function MultiColumnWithHorizontalLines({ segment, ...props }) {
  const gridColClasses = {
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
  };
  const contentTextSizeClasses = {
    2: "md:text-lg",
    3: "md:text-lg",
    4: "md:text-base",
  };

  return (
    <SegmentContainer className={props.paddingClasses}>
      <div className={props.widthClasses}>
        <div
          className={classNames("grid", gridColClasses[segment.blocks.length])}
        >
          {segment.blocks.map((block) => {
            return (
              <Fragment key={block._key}>
                <div
                  className={classNames(
                    "col-span-full sm:col-span-1 sm:row-start-1",
                    "py-8 px-[6%] sm:pl-[9%] sm:pr-[18%] border-y border-dark-purple",
                    "font-semibold text-dark-purple whitespace-pre-line",
                    props.headingSizeClasses[block.headingSize] ||
                      "text-xl sm:text-2xl"
                  )}
                >
                  <div className="mb-2">{getIconImage(block.icon, "24px")}</div>
                  <PortableTextPlus value={block.heading} />
                </div>
                <div
                  className={classNames(
                    "col-span-full sm:col-span-1",
                    "pt-8 pb-12 px-[6%] sm:pl-[9%] sm:pr-[18%]",
                    "md:border-b border-dark-purple space-y-10 leading-snug prose",
                    contentTextSizeClasses[segment.blocks.length]
                  )}
                >
                  <PortableTextPlus value={block.content} />
                </div>
              </Fragment>
            );
          })}
        </div>
      </div>
    </SegmentContainer>
  );
}
